import type { PurchasesPackage as PackageCapacitor } from '@revenuecat/purchases-capacitor';
import type { Package as PackageJs } from '@revenuecat/purchases-js';

import type { Package } from '@/integrations/revenuecat/types';

export async function purchasePackage(pkg: Package) {
  if (import.meta.env.VITE_PLATFORM === 'MOBILE') {
    const { Purchases } = await import('@revenuecat/purchases-capacitor');
    return Purchases.purchasePackage({
      aPackage: pkg.rcPackage as PackageCapacitor,
    });
  }

  // Web: inject custom overlay styles for Paddle checkout
  const { injectCheckoutOverlay } = await import('./checkoutOverlay');
  const cleanupOverlay = injectCheckoutOverlay();

  const { Purchases } = await import('@revenuecat/purchases-js');

  // Don't use try/catch - if purchase fails, error propagates naturally and
  // cleanupOverlay won't be called. RevenueCat shows an error page that needs styling,
  // and MutationObserver in checkoutOverlay will cleanup when user dismisses it.
  const result = await Purchases.getSharedInstance().purchase({
    rcPackage: pkg.rcPackage as PackageJs,
  });

  cleanupOverlay();
  return result;
}
